import s from './blocker-router-modal.module.scss'
import { Modal } from '@shared/ui/modal/modal';
import { Button } from '@shared/ui/button/button';

export const BlockerRouterModal = ({isOpen, modalParams, close}) => {	
	const props = modalParams

  return (
		<Modal {...{isOpen, close}}>
			<div className={s.card}>
					<div className={s.title}>Вы хотите перейти на другую страницу?</div>
					<div className={s.text}>Если вы покинете страницу, конференция прервется</div>
					<div className={s.btns}>
						<Button
							theme='secondary'
							className={s.btn}
							onClick={() => {
								props?.onConfirm()
							}}
							label={'Перейти'}
						/>
						<Button
							className={s.btn}
							onClick={() => {
								props?.onCancel()
							}}
							label={'Остаться'}
						/>
					</div>
			</div>
		</Modal>
  );
};